import { render } from "./Players.vue?vue&type=template&id=7042683b&scoped=true"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"

import "./Players.vue?vue&type=style&index=0&id=7042683b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7042683b"]])

export default __exports__